/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTODocumentSelectResponseDTO } from '../models/ApiResponseDTODocumentSelectResponseDTO';
import type { ApiResponseDTODocumentStatusResponseDTO } from '../models/ApiResponseDTODocumentStatusResponseDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DocumentApiService {

    /**
     * Get the submitted document status
     * Retrieve the document status submitted to SmileID
     * @param jobId
     * @returns ApiResponseDTODocumentStatusResponseDTO OK
     * @throws ApiError
     */
    public static getDocumentStatus(
        jobId: string,
    ): CancelablePromise<ApiResponseDTODocumentStatusResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/documents/status/job/{jobId}',
            path: {
                'jobId': jobId,
            },
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get document List supported in the step
     * Return the list of documents supported in the step
     * @param step
     * @returns ApiResponseDTODocumentSelectResponseDTO OK
     * @throws ApiError
     */
    public static getDocumentSelect(
        step: 'NIGERIA_DOCUMENT_VERIFICATION' | 'NIGERIA_PROOF_ADDRESS' | 'GHANA_UTILITY_BILL_TIER_3' | 'GHANA_BUSINESS_TYPE_TIER_4' | 'GHANA_DIRECTORS_DETAIL_CITIZEN_TIER_4' | 'GHANA_DIRECTORS_DETAIL_FOREIGNER_TIER_4',
    ): CancelablePromise<ApiResponseDTODocumentSelectResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/documents/step/{step}',
            path: {
                'step': step,
            },
            errors: {
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

}
